import { membersApi } from "@services/apiMembersClient";
import {
  CreateContentResourceInput,
  CreateContentResourceOutput,
  GetContentResourceInput,
  GetContentResourceOutput,
  UpdateContentResourceInput,
} from "@_types/contentResources";
import {
  CreateSignedUrlInput,
  CreateSignedUrlOutput,
  ResponsePaginationType,
  UploadSignedUrlInput,
} from "@_types/shared";
import axios, { AxiosProgressEvent, AxiosPromise } from "axios";

export const getContentResource = (
  params: GetContentResourceInput
): AxiosPromise<ResponsePaginationType<GetContentResourceOutput>> => {
  return membersApi.get("/resources", { params });
};

export const getContentResourceById = (uuid: string): AxiosPromise<GetContentResourceOutput> => {
  return membersApi.get(`/resources/${uuid}`);
};

export const createContentResource = (
  data: CreateContentResourceInput,
  onUploadProgress: (event: AxiosProgressEvent) => void
): AxiosPromise<CreateContentResourceOutput> => {
  return membersApi.post("/resources", data, {
    onUploadProgress,
  });
};

export const updateContentResourceById = (
  uuid: string,
  data: UpdateContentResourceInput
): AxiosPromise<GetContentResourceOutput> => {
  return membersApi.patch(`/resources/${uuid}`, data);
};

export const deleteContentResource = (uuid: string): AxiosPromise<void> => {
  return membersApi.delete(`/resources/${uuid}`);
};

// upload requests
export const createContentResourceSignedUrl = (data: CreateSignedUrlInput): AxiosPromise<CreateSignedUrlOutput> => {
  return membersApi.post("/resources", data);
};

export const uploadContentResourceToSignedUrl = (
  url: string,
  formData: UploadSignedUrlInput,
  onUploadProgress: (event: AxiosProgressEvent) => void
) => {
  return axios.postForm(url, formData, { onUploadProgress });
};
